import * as React from 'react'

const ArrowDouble = ({
	size = 20,
	color = '#525252',
	strokeWidth = 1.5,
	...props
}) => {
	return (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 20 20"
		fill="none"
		{...props}
	>

		<path
			d="M6 12L6 4"
			stroke={color}
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>

		<path
			d="M2.66695 7.33333L6.00028 4L9.33362 7.33333"
			stroke={color}
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>

		<path
			d="M13.6665 8.41666L13.6665 16.4167"
			stroke={color}
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>

		<path
			d="M10.3335 13.0833L13.6668 16.4167L17.0001 13.0833"
			stroke={color}
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>

	</svg>
)
}

export default ArrowDouble
